import Reflux from 'reflux';

export default Reflux.createActions([
    'onProjectsLoad', 'onIssuesLoad', 'onResetData',
    'onIssueVisibilityToggled', 'onIssueVisibilitySet', 'onMyProjectToggled'
]);
